import { useState } from "react";
import { Box } from "@mui/system";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
// import Footer from "./Footer";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
// import { ToastContainer } from "react-toastify";

function Layout(props) {
  const [toggleDrawer, setToggleDrawer] = useState(true);
  // const [disableMouseover, setDisableMouseover] = useState(true);

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

  const onToggleDrawer = () => {
    setToggleDrawer(!toggleDrawer);
  };

  return (
    <>
      {!isLargeScreen ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            Please use a laptop or desktop for better experience
          </Typography>
        </Box>
      ) : (
        <Box display="flex" flex={1} height="100vh" width="100vw">
          {isLargeScreen ? (
            <Sidebar
              toggleDrawer={toggleDrawer}
              isLargeScreen={isLargeScreen}
              setToggleDrawer={setToggleDrawer}
            />
          ) : (
            <Sidebar
              toggleDrawer={toggleDrawer}
              setToggleDrawer={setToggleDrawer}
            />
          )}
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            overflow="auto"
          >
            <Box sx={{ position: "sticky", top: 0, zIndex: 999 }}>
              <Topbar
                onToggleDrawer={onToggleDrawer}
                toggleDrawer={toggleDrawer}
              />
            </Box>
            <main
              flex={1}
              overflow="auto"
              // overflowX="auto"
              style={{ zIndex: 998 }}
            >
              {props.children}
            </main>
            {/* <Box sx={{ position: "static", top: 0 }}><Footer /></Box> */}
          </Box>
        </Box>
      )}
    </>
  );
}

export default Layout;
